import { useActiveUnit } from "components/Unit";
import { atom, useAtom } from "jotai";

const isOpenHouseDrawer = atom(false);

const useOpenHouseDrawer = () => {
  const [isOpen, setIsOpen] = useAtom(isOpenHouseDrawer);
  const unit = useActiveUnit();

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const open = (unit) => {
    setIsOpen(true);
  };

  return { toggle, open, isOpen, unit };
};

export { useOpenHouseDrawer };
